import deMessages from '../messages/de.json';
import enMessages from '../messages/en.json';
import { useLang } from './app';
import '@formatjs/intl-relativetimeformat/locale-data/de';
import '@formatjs/intl-relativetimeformat/locale-data/en';
import '@formatjs/intl-relativetimeformat/polyfill';
import { FC } from 'react';
import { IntlProvider } from 'react-intl';
import { WithChildren } from 'ts-types';

const allMessages = {
  de: deMessages,
  en: enMessages
};

const I18nProvider: FC<WithChildren> = ({ children }) => {
  const locale = useLang();
  const messages = allMessages[locale];

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
};

export { I18nProvider };
